module.exports = __webpack_public_path__ + "img/exportURL3.71fc8ef4.png";